import StatisticalAnalysisSkeletonDossierNavigationItems from '@/modules/statistical-analysis-module/components/statistical-analysis-skeletons/statistical-analysis-skeleton-dossier-navigation-items/statistical-analysis-skeleton-dossier-navigation-items.vue'
import StatisticalAnalysisSkeletonGeneralDossierTrackingItems from '@/modules/statistical-analysis-module/components/statistical-analysis-skeletons/statistical-analysis-skeleton-general-dossier/statistical-analysis-skeleton-general-dossier-tracking-items/statistical-analysis-skeleton-general-dossier-tracking-items.vue'
import { Vue, Component } from 'vue-property-decorator'

@Component({
    components: {
        StatisticalAnalysisSkeletonGeneralDossierTrackingItems,
        StatisticalAnalysisSkeletonDossierNavigationItems
    }
})
export default class StatisticalAnalysisSkeletonGeneralDossierBase extends Vue {}
